// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.ResetPassword.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import AccountInfo from 'modules/Account/Izenda.AccountInfo';
import SimpleSecurityInfo from 'modules/Account/Izenda.SimpleSecurityInfo';
import PasswordInfo from 'modules/Account/Izenda.PasswordInfo';
import actions from 'modules/Account/Izenda.ResetPasswordActions';

@connect(actions)
export default class ResetPassword extends Component {
  componentWillMount() {
    this.props.updateToAccountInfoStep(this);
  }
  render() {
    const { store } = this.props;
    return (
      <div className='izenda-Account-PasswordSetup u_inlineBlock'>
        <AccountInfo store={store} />
        <SimpleSecurityInfo store={store} />
        <PasswordInfo store={store} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.ResetPassword.js